import React from "react";
import Tooltip from "@mui/material/Tooltip";

const ellipsisStyle: React.CSSProperties = {
  display: '-webkit-box',
  WebkitLineClamp: 1,         
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'normal',        
  maxWidth: 180,               
  fontWeight: 500,
  lineHeight: 1.15,           
  cursor: 'pointer',          
};
export function useTypingEffect(fullText: string, speed: number = 10, disabled = false) {
  const [displayed, setDisplayed] = React.useState("");

  React.useEffect(() => {
    if (disabled || !fullText) {
      setDisplayed(fullText);
      return;
    }
    let i = 0;
    setDisplayed("");
    const interval = setInterval(() => {
      setDisplayed((prev) => prev + fullText[i]);
      i++;
      if (i >= fullText.length) clearInterval(interval);
    }, speed);

    return () => clearInterval(interval);
  }, [fullText, speed, disabled]);

  return displayed;
}

const TypingTitle: React.FC<{
  title: string;
  animate?: boolean; 
}> = ({ title, animate = false }) => {
  const typed = useTypingEffect(title, 23, !animate);
  return (
    <Tooltip title={title} arrow>
      <span style={ellipsisStyle}>{typed}</span>
    </Tooltip>
  );
};

export default TypingTitle;
